import { StyledTypography } from './styles';

export default StyledTypography;
